
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../App.tsx';
import { AppStep } from '../types.ts';
import { generateCode } from '../services/gemini.ts';
import { Loader2, Terminal } from 'lucide-react';

const GenerationPage: React.FC = () => {
  const ctx = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const process = async () => {
      if (!ctx?.state.extractionData || !ctx?.state.designData) return;
      try {
        setLoading(true);
        const code = await generateCode(ctx.state.extractionData, ctx.state.designData);
        ctx.dispatch({ type: 'SET_CODE', payload: code });
        // Automatically move to code view after brief delay
        setTimeout(() => {
          ctx.dispatch({ type: 'SET_STEP', payload: AppStep.CODE_VIEW });
        }, 1500);
      } catch (err: any) {
        ctx?.dispatch({ type: 'SET_ERROR', payload: err.message });
      } finally {
        setLoading(false);
      }
    };
    process();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="relative mb-6">
        <Terminal className="w-16 h-16 text-emerald-500 animate-pulse" />
        <Loader2 className="w-16 h-16 text-emerald-500/20 animate-spin absolute inset-0" />
      </div>
      <h2 className="text-2xl font-bold mb-2">Engine 3: Code Generation</h2>
      <p className="text-slate-400 max-w-md">The final agent is executing Code Generation and Optimization to produce the production-ready functional output.</p>
      
      <div className="mt-12 w-full max-w-lg bg-slate-900 border border-slate-800 rounded-2xl p-6 text-left">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-3 h-3 rounded-full bg-red-500" />
          <div className="w-3 h-3 rounded-full bg-yellow-500" />
          <div className="w-3 h-3 rounded-full bg-green-500" />
        </div>
        <div className="space-y-2 font-mono text-xs text-slate-500">
          <p className="text-emerald-500">&gt;&gt; Initializing Tailwind CDN compiler...</p>
          <p className="text-emerald-500">&gt;&gt; Mapping 1000px grid to responsive Flexbox...</p>
          <p className="text-emerald-500">&gt;&gt; Injecting Design System variables...</p>
          <p className="animate-pulse text-indigo-400">&gt;&gt; Compiling final HTML/CSS output...</p>
        </div>
      </div>
    </div>
  );
};

export default GenerationPage;
